import { IResponse } from "models";

export enum ActionType {
  CONTRACT_INFORMATION_INQUIRY_DETAIL = "action/CONTRACT_INFORMATION_INQUIRY_DETAIL",
  CONTRACT_INFORMATION_INQUIRY_DETAIL_SUCCESS = "action/CONTRACT_INFORMATION_INQUIRY_DETAIL_SUCCESS",
  CONTRACT_INFORMATION_INQUIRY_DETAIL_ERROR = "action/CONTRACT_INFORMATION_INQUIRY_DETAIL_ERROR",
  CONTRACT_INFORMATION_INQUIRY_DETAIL_RESET = "action/CONTRACT_INFORMATION_AUTO_RELEASE_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IInquiryDetailPayload {
  inquiry_email: string;
  inquiry_desc: string;
}

export interface IInquiryDetailResponse extends IResponse {
  result: any;
}
